import {
  VersionErroredAction,
  VersionLoadedAction,
  VersionPageLoadedAction,
} from './version.action';
import { VersionApiError } from './version.errors';
import { createReducer, on } from '@ngrx/store';
import { Version } from './version.model';

export interface VersionState {
  versions: Version[];
  apiError: VersionApiError;
}

export const initialState = {
  versions: [],
  apiError: null,
};

export const versionReducer = createReducer(
  initialState,
  on(VersionPageLoadedAction, (state) => ({
    ...state,
    versions: [],
    apiError: null,
  })),
  on(VersionLoadedAction, (state, { versions }) => ({
    ...state,
    apiError: null,
    versions,
  })),
  on(VersionErroredAction, (state, { error }) => ({ ...state, apiError: error })),
);
